import { WSPillProps } from "@wingspanhq/fe-component-library";
import {
  RecurringDocumentStatus,
  RecurringInvoice
} from "@wingspanhq/wingspan-api-sdk";

export const getRecurringInvoiceStatusPillProps = (
  recurringInvoice: RecurringInvoice
): WSPillProps => {
  const status = recurringInvoice.status;

  if (!status) {
    return {
      theme: "neutral",
      icon: "info-circle",
      text: "Status unavailable"
    };
  }

  switch (status) {
    case RecurringDocumentStatus.DRAFT:
      return { theme: "neutral", icon: "draft", text: "Draft" };

    case RecurringDocumentStatus.ACTIVE:
      return { theme: "blue", icon: "calendar", text: "Scheduled" };

    case RecurringDocumentStatus.PAUSED:
      return { theme: "warning", icon: true, text: "Paused" };

    case RecurringDocumentStatus.COMPLETED:
      return { theme: "success", icon: true, text: "Complete" };

    case RecurringDocumentStatus.CANCELLED:
      return { theme: "neutral", icon: "exit-circle", text: "Cancelled" };

    default:
      return { theme: "warning", icon: true, text: "Unrecognized status" };
  }
};
